import { Button, Grid, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { ErrorIllustration } from '../../assets/illustration';
import { APP_URLS } from '../../routes/urls';
import { AppIcon } from '../app-icon/AppIcon';
import { ERROR_MESSAGES } from './constants';
import { errorComponentStyles } from './styles';

interface ErrorComponentProps {
  errorStatus?: number | string;
}

export const ErrorComponent: React.FC<ErrorComponentProps> = ({ errorStatus = 'default' }) => {
  const errorMessage = ERROR_MESSAGES[errorStatus] || ERROR_MESSAGES['default'];

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      direction={{ xs: 'column-reverse', md: 'row' }}
      className="container-fluid"
      spacing={2.5}
      sx={{ py: 7.5 }}
    >
      <Grid sx={errorComponentStyles.contentContainer} item xs="auto" md={6} lg={4}>
        <Typography variant="h3" sx={{ mb: 7.5 }}>
          Oops..
          <br />
          {errorMessage.title}
        </Typography>
        <Typography variant="medium" color="secondary">
          {errorMessage.message}
        </Typography>
        <Box sx={{ mt: 2.5 }}>
          <Button variant="contained" component={Link} to={APP_URLS.home}>
            Go to Home
          </Button>
        </Box>
      </Grid>
      <Grid item xs="auto" md={6} sx={{ textAlign: 'right' }}>
        <AppIcon
          titleAccess={errorMessage.title}
          sx={errorComponentStyles.svg}
          Icon={ErrorIllustration}
          role="presentation"
        />
      </Grid>
    </Grid>
  );
};
